import React, { useCallback, useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Select, Input, Layout } from '../../../components';
import SelectType from '../../../components/Form/Select/select_type';
import { useToast } from '../../../hooks/toast';
import { RoutesPaths } from '../../../routes';
import api from '../../../services/api';
import type { PerfilData } from '../../../shared/interfaces/perfil';
import type { ScreenData } from '../../../shared/interfaces/screen';
import getValidationErrors from '../../../utils/getValidationErrors';
import { Container, FormContainer, FormFooter } from './styles';

const Cadastro: React.FC = () => {
  const formRef = useRef<FormHandles | null>(null);
  const history = useHistory();
  const { addToast } = useToast();

  const [dataTable, setDataTable] = useState<SelectType[]>([]);
  let selectedScreens = useRef<number[] | null>(null);

  const fetchData = useCallback(async () => {
    try {
      const response = await api.get<ScreenData[]>(`/tela`);

      let screenValues: SelectType[] = response.data.map(
        (screen: ScreenData) => {
          return {
            value: screen.id,
            label: screen.titulo,
          };
        },
      );

      setDataTable(screenValues);
    } catch (e) {
      console.error(e);
    }
  }, []);
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSubmit = useCallback(
    async (data: PerfilData) => {
      data.idTelasList = selectedScreens.current;

      data.nomePerfil.trim();

      try {
        if (!data.idTelasList?.length) {
          const schemaSelect = Yup.object().shape({
            id: Yup.string().max(25, 'No máximo 25 caracteres'),
            nomePerfil: Yup.string()
              .max(200, 'No máximo 200 caracteres')
              .matches(
                /^(?!\s*$)[-a-zA-Z0-9_:,.]/,
                'Um ou mais caracteres digitados não são permitidos!',
              )
              .required('Este campo é obrigatório!'),
            select: Yup.string().required('Este campo é obrigatório!'),
          });

          data.nomePerfil.trim();

          await schemaSelect.validate(data, {
            abortEarly: false,
          });
        }
        const schema = Yup.object().shape({
          id: Yup.string().max(25, 'No máximo 25 caracteres'),
          nomePerfil: Yup.string()
            .max(200, 'No máximo 200 caracteres')
            .matches(
              /^(?!\s*$)[-a-zA-Z0-9_:,.]/,
              'Um ou mais caracteres digitados não são permitidos!',
            )
            .required('Este campo é obrigatório!'),
        });

        data.nomePerfil.trim();

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post('/perfil', data);
        addToast({
          type: 'success',
          title: 'Perfil cadastrado com sucesso!',
          description:
            'As informações de Perfil foram cadastradas. Você pode verificar o novo Perfil na seção de Listagem de Perfis.',
        });

        setTimeout(() => {
          history.push(RoutesPaths.listPerfil);
        }, 3000);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errorMessages = getValidationErrors(err);
          formRef.current?.setErrors(errorMessages);
          return;
        } else {
          console.error(err);
          addToast({
            type: 'error',
            title: 'Perfil já cadastrado!',
            description:
              'As informações que foram inseridas, já estão presentes no sistema.',
          });
        }
      }
    },
    [addToast, history],
  );

  function handleScreenChange(dataTable: []) {
    if (dataTable) {
      const valor = dataTable.map((item: any) => item['value']);
      selectedScreens.current = valor;
    }
  }

  return (
    <Layout title="Cadastro de Perfis" hideFloatingButton>
      <Container>
        <FormContainer>
          <Form
            className="form-container"
            ref={formRef}
            onSubmit={handleSubmit}
          >
            <Input name="nomePerfil" label="Nome" type="text" />

            <Select
              name={'select'}
              options={dataTable}
              onChange={handleScreenChange}
              placeholder="Selecione"
              label="Telas disponíveis"
              loading={!dataTable.length ? true : false}
            />

            <FormFooter>
              <Button
                variant="solid"
                style={{ marginTop: '1rem' }}
                type="submit"
                disabled={!dataTable.length}
              >
                Salvar
              </Button>
            </FormFooter>
          </Form>
        </FormContainer>
      </Container>
    </Layout>
  );
};

export default Cadastro;
